import SharedCountdownPage from "@/features/_shared/pages/CountdownPage";
import { dataProps } from "@/models/data.model";
import { FC, JSX } from "react";

import CountdownUI from "./CountdownUI/CountdownUI";

const ChallengeUpcoming: FC<dataProps> = (data): JSX.Element => (
  <SharedCountdownPage {...data} UI={CountdownUI} />
);

export default ChallengeUpcoming;
